import Fuse, { FuseResult } from "fuse.js";
import { TranslatableItem } from "../types/cityEscape";
import { LangSwitchOption } from "../types/misc";

const LENGTH_RATIO_THRESHOLD = 1.2;
const MIN_MATCH_CHAR_LENGTH = 3;
const THRESHOLD = 0.2;

export const normalizeString = (str: string): string => {
  return str
    .replace(/[.,\/#!$%\^&\*;:{}=\-_`~()]/g, " ")
    .replace(/\s{2,}/g, " ")
    .trim();
};

export const fuzzyMatch = (
  value: string,
  items: string[],
  inclusion: boolean = false
): boolean => {
  const normalizedValue = normalizeString(value);
  const normalizedItems = items.map((item) => normalizeString(item));
  const results: FuseResult<string>[] = [];
  if (inclusion) {
    for (const item of normalizedItems) {
      const fuse = new Fuse(normalizedValue.split(" "), {
        threshold: THRESHOLD,
        includeScore: true,
        isCaseSensitive: false,
        minMatchCharLength: MIN_MATCH_CHAR_LENGTH,
      });
      const tokenFuzzyResult = item
        .split(" ")
        .every((token) => fuse.search(token).length > 0);
      if (tokenFuzzyResult) {
        return true;
      }
    }
  } else {
    const fuse = new Fuse(normalizedItems, {
      threshold: THRESHOLD,
      includeScore: true,
      isCaseSensitive: false,
      minMatchCharLength: MIN_MATCH_CHAR_LENGTH,
    });
    results.push(...fuse.search(normalizedValue));
  }
  const matched = results.find(
    (result) => result.item.length / value.length <= LENGTH_RATIO_THRESHOLD
  );

  return !!matched;
};

export function isSceneTargetOfMultipleExits(
  sceneId: string,
  scenes: Array<{ output_scenes_exits?: Array<{ target_scene: string }> }>
): boolean {
  let count = 0;
  for (const scene of scenes) {
    if (scene.output_scenes_exits) {
      for (const exit of scene.output_scenes_exits) {
        if (exit.target_scene === sceneId) {
          count++;
          if (count > 1) {
            return true;
          }
        }
      }
    }
  }
  return false;
}

export function getActiveTranslation(
  item: TranslatableItem | null | undefined,
  lang: LangSwitchOption
) {
  const translations = item?.translations;
  for (const translation of translations || []) {
    if (translation.languages_code === lang) {
      return translation;
    }
  }

  return undefined;
}

export function getGameLink(match?: {
  order_type: string;
  order_id: string;
}): string | undefined {
  if (!match) {
    return undefined;
  }
  return `https://play.garipalli.com/it/city-escape/${match?.order_type}?game=${match?.order_id}`;
}
